export const LockedDepartment = 'locked-department';
